import _ from 'underscore';
import Environment from "../../common/environment";
import Tracking from '../../common/tracking';
import OriginTracing from '@atlassiansox/origin-tracing';
import tracking from '../../utils/tracking';

export default class SocialLogin {
  constructor(
    baseDomain: string,
    baseIdDomain: any,
    hamlet: { isLoggedIn: () => any; getSites: () => any[]; getExtendedTrialAvailableSites: () => any; },
    jQuery: JQueryStatic,
    imktUtils: { storage: { getCookie: (arg0: string) => string; }; },
    localeParam: any,
    urlRenameSitePath: any
  ) {

    const URL_CONFIRMATION_PATH = '/ondemand/signup/confirmation';
    const URL_LOGIN_GOOGLE_PATH = '/login/initiate/google';
    const URL_LOGIN_MICROSOFT_PATH = '/login/initiate/microsoft';
    const URL_RENAME_SITE_PATH = urlRenameSitePath;
    const URL_SIGNUP_SOCIAL_LOGIN_PATH = '/try/cloud/signup-social-login';
    const URL_TRY_CLOUD_SIGNUP_PATH = '/try/cloud/signup';
    const URL_IDENTITY_LOGOUT_PATH = '/logout';

    const SIGNUP_ATLLOGO_CONTAINER_CLASS = 'atl-logo';
    const SIGNUP_CONTENT_CONTAINER_CLASS = 'signup-content';
    const SOCIAL_LOGIN_WAIT_CONTAINER_CLASS = 'social-login-wait-banner';
    const SOCIAL_LOGIN_ERROR_CONTAINER_CLASS = 'social-login-error-display';
    const SOCIAL_LOGIN_CHECKING_WAIT_TEXT_CLASS = 'checking-wait-text';
    const SOCIAL_LOGIN_PREPARING_WAIT_TEXT_CLASS = 'preparing-wait-text';
    const SOCIAL_LOGIN_ERROR_TRYAGAIN_ID = '#try-signup-again';


    const WAC_SIGNUP_GOOGLE = 'wac-signup-google';
    const loginGoogleOrigin = new OriginTracing({ product: WAC_SIGNUP_GOOGLE });

    const WAC_SIGNUP_MICROSOFT = 'wac-signup-microsoft';
    const loginMicrosoftOrigin = new OriginTracing({ product: WAC_SIGNUP_MICROSOFT });

    const WAC_TRY_SIGNUP = 'wac-try-signup';
    const trySignupOrigin = new OriginTracing({ product: WAC_TRY_SIGNUP });

    const SS_SOCIAL_LOGIN_CLOUDDATA_KEY = 'w.s.l.c.d';

    return {
      init: function () {
        if (!this.detectSocialLoginPage()) {
          this.sessionStorageClearCloudData();
        }
      },

      sessionStorageSaveCloudData: function (userDetails, cloudDetails) {
        window.sessionStorage.setItem(SS_SOCIAL_LOGIN_CLOUDDATA_KEY, window.btoa(JSON.stringify({ userDetails, cloudDetails })));
      },

      sessionStorageGetCloudData: function () {
        const cloudData = window.sessionStorage.getItem(SS_SOCIAL_LOGIN_CLOUDDATA_KEY);
        if (cloudData) {
          try {
            return JSON.parse(window.atob(cloudData));
          } catch (e) {
            return JSON.parse(window.atob({ cloudData }));
          }
        }
        return undefined;
      },

      sessionStorageClearCloudData: function () {
        window.sessionStorage.removeItem(SS_SOCIAL_LOGIN_CLOUDDATA_KEY);
      },

      /**
       * Determine search params
       * - if the form settings have products AND/OR edition set
       * - we are going to replace the current paraems with the dialog's
       */
      determineSearchParams: function (products, edition) {
        var urlParams = new URLSearchParams(this.getCurrentSearchParam());

        // delete bundle
        urlParams.delete("bundle");
        urlParams.set('product', products);

        if (edition) {
          urlParams.set('edition', edition);
        }
        return urlParams.toString();
      },

      /**
       * Render social login UI components:
       * - Continue with Google
       * - Sign up with email
       */
      renderSocialLogin: function ({
        enableContinueWithGoogle,
        enableContinueWithMicrosoft,
        labels,
        products,
        edition
      }) {
        const self = this;
        const searchParams = self.determineSearchParams(products, edition);
        if (enableContinueWithGoogle && enableContinueWithMicrosoft) {
          self.renderGoogleAndMicrosoftLogin(labels, searchParams);
        }
        else if (enableContinueWithGoogle) {
          self.renderGoogleLogin(labels, searchParams);
        }
        else if (enableContinueWithMicrosoft) {
          self.renderMicrosoftLogin(labels, searchParams);
        }
      },

      /**
       * Render Google login UI components:
       * - Continue with Google
       * - Sign up with email
       */
      renderGoogleLogin: function (labels, searchParams) {
        const self = this;

        const formContainer = jQuery('.imkt--cloud-signup');
        const socialHeading = formContainer.find('.heading--social-show');
        formContainer.addClass('social-login');

        // Hide the full signup form
        const fullForm = jQuery('.imkt--cloud-signup__form');
        fullForm.detach();
        fullForm.addClass('hidden');

        // Construct the new social login form from template
        const googleSignInFormTemplate = _.template(jQuery('.template--cloud-signup__form--continue-with-google').html());
        const newForm = jQuery('<div />');
        newForm
          .append(googleSignInFormTemplate({ labels: labels }))
          .append(fullForm)
          .insertAfter('.imkt--cloud-signup .heading--products');

        // Continue with Google button
        const googleSigninButton = newForm.find('#google-signup');
        googleSigninButton.prop('href', this.getContinueWithGoogleUrl(searchParams));
        googleSigninButton.click(() => {
          self.sendTrackingAnalytics("Clicked Google Button", {}, false);
          tracking.trackEvent(WAC_SIGNUP_GOOGLE, loginGoogleOrigin.toAnalyticsAttributes({ hasGeneratedId: true }));
        });

        // Continue with email button
        const emailSigninButton = newForm.find('.btn.email-signup');

        // WCF-1796 we need to add more bottom margin to account for the heading
        // TO-DO add same treatment to Microsoft and both in the furture
        if (socialHeading) {
          emailSigninButton.css("margin-bottom", "20px");
        }

        emailSigninButton.click(() => {
          self.sendTrackingAnalytics("Clicked Email Button", {}, false);
          formContainer.addClass('form-shown');
          emailSigninButton.addClass('clicked');
          fullForm.removeClass('hidden');
          socialHeading.remove();
        });
      },


      /**
       * Render Microsoft login UI components:
       * - Continue with Microsoft
       * - Sign up with email
       */
      renderMicrosoftLogin: function (labels, searchParams) {
        const self = this;

        const formContainer = jQuery('.imkt--cloud-signup');
        formContainer.addClass('social-login');

        // Hide the full signup form
        const fullForm = jQuery('.imkt--cloud-signup__form');
        fullForm.detach();
        fullForm.addClass('hidden');

        // Construct the new social login form from template
        const microsoftSignInFormTemplate = _.template(jQuery('.template--cloud-signup__form--continue-with-microsoft').html());
        const newForm = jQuery('<div />');
        newForm
          .append(microsoftSignInFormTemplate({ labels: labels }))
          .append(fullForm)
          .insertAfter('.imkt--cloud-signup .heading--products');

        // Continue with Microsoft button
        this.renderMicrosoftButton(newForm, searchParams);

        // Continue with email button
        const emailSigninButton = newForm.find('.btn.email-signup');
        emailSigninButton.click(() => {
          self.sendTrackingAnalytics("Clicked Email Button", {}, false);
          formContainer.addClass('form-shown');
          emailSigninButton.addClass('clicked');
          fullForm.removeClass('hidden');
        });
      },

      /**
       * Render Google and Microsoft login UI components:
       * - Continue with Google
       * - Continue with Microsoft
       * - Sign up with email
       */
      renderGoogleAndMicrosoftLogin: function (labels, searchParams) {
        const self = this;

        const formContainer = jQuery('.imkt--cloud-signup');
        formContainer.addClass('social-login');

        // Hide the full signup form
        const fullForm = jQuery('.imkt--cloud-signup__form');
        fullForm.detach();
        fullForm.addClass('hidden');

        // Construct the new social login form from template
        const socialSignInFormTemplate = _.template(jQuery('.template--cloud-signup__form--continue-with-google-and-microsoft').html());
        const newForm = jQuery('<div />');
        newForm
          .append(socialSignInFormTemplate({ labels: labels }))
          .append(fullForm)
          .insertAfter('.imkt--cloud-signup .heading--products');

        // Continue with Google button
        this.renderGoogleButton(newForm, searchParams);

        // Continue with Microsoft button
        this.renderMicrosoftButton(newForm, searchParams);

        // Continue with email button
        const emailSigninButton = newForm.find('.btn.email-signup');
        emailSigninButton.click(() => {
          self.sendTrackingAnalytics("Clicked Email Button", {}, false);
          formContainer.addClass('form-shown');
          emailSigninButton.addClass('clicked');
          fullForm.removeClass('hidden');
        });
      },

      /**
       * Render Continue with Google button
       */
      renderGoogleButton: function (newForm, searchParams) {
        const self = this;

        // Continue with Google button
        const googleSigninButton = newForm.find('#google-signup');
        googleSigninButton.prop('href', this.getContinueWithGoogleUrl(searchParams));
        googleSigninButton.click(() => {
          self.sendTrackingAnalytics("Clicked Google Button", {}, false);
          tracking.trackEvent(WAC_SIGNUP_GOOGLE, loginGoogleOrigin.toAnalyticsAttributes({ hasGeneratedId: true }));
        });
      },

      /**
       * Render Continue with Microsoft button
       */
      renderMicrosoftButton: function (newForm, searchParams) {
        const self = this;

        // Continue with Microsoft button
        const microsoftSigninButton = newForm.find('#microsoft-signup');
        microsoftSigninButton.prop('href', this.getContinueWithMicrosoftUrl(searchParams));
        microsoftSigninButton.click(() => {
          self.sendTrackingAnalytics("Clicked Microsoft Button", {}, false);
          tracking.trackEvent(WAC_SIGNUP_MICROSOFT, loginMicrosoftOrigin.toAnalyticsAttributes({ hasGeneratedId: true }));
        });
      },

      /**
       * Determine whether the current flow is part of a social login
       */
      detectSocialLoginPage: function () {
        return (window.location.pathname.indexOf(URL_SIGNUP_SOCIAL_LOGIN_PATH) >= 0);
      },

      /**
       * Determine if the user is on signup-social-login page with email, firstName and lastName info
       */
      isValidSocialLoginUser: function (user) {
        const isUserLoggedIn = hamlet.isLoggedIn();
        const isValidUser = (
          this.detectSocialLoginPage() &&
          hamlet.isLoggedIn() &&
          user && user.myDetails &&
          user.myDetails.email &&
          user.myDetails.firstName &&
          user.myDetails.lastName);
        if (!isValidUser) {
          this.sendTrackingAnalytics("Detected Invalid User", { isUserLoggedIn });
        }
        return isValidUser;
      },

      /**
       * Determine if the user is in social login flow
       */
      isSocialLogin: function (user, productKeys, newUsersOnlyRestriction, existingUserCloudData) {
        if (this.detectSocialLoginPage()) {
          this.sendTrackingAnalytics("Viewed Checking Page", { productKeys });

          try {
            const cloudData = this.sessionStorageGetCloudData();
            if (cloudData) {
              if (cloudData.cloudDetails && cloudData.userDetails &&
                user.myDetails && cloudData.userDetails.email === user.myDetails.email) {
                // Back to this signup social login page using the same account,
                // should proceed to rename site page directly.
                this.sendTrackingAnalytics("Detected Back Same Account", { cloudDetails: cloudData.cloudDetails });
                if (existingUserCloudData) {
                  existingUserCloudData.cloudDetails = cloudData.cloudDetails;
                }
                return true;
              } else {
                // Back to this signup social login page using a different account,
                // should proceed to N2E signup form.
                this.sendTrackingAnalytics("Detected Back Diff Account", { cloudDetails: cloudData.cloudDetails });
              }
            } else {
              const eligibleSites = this.getEligibleSites(user, productKeys);
              if (eligibleSites && eligibleSites.length) {
                // Has eligible sites -> N2E
                const eventProps = { numEligibleSites: eligibleSites.length, productKeys };
                this.sendTrackingAnalytics("Found Eligible Sites", eventProps);
              } else {
                // No eligible sites, check all existing sites
                const existingSites = hamlet.getSites();
                if (existingSites && existingSites.length) {
                  // Has existing sites but none are eligible for the target product
                  const eventProps = { numExistingSites: existingSites.length, productKeys };
                  this.sendTrackingAnalytics("Found Existing Sites", eventProps);
                  return !newUsersOnlyRestriction;
                } else {
                  // No existing sites -> N2N
                  this.sendTrackingAnalytics("Found No Sites", {});
                  return true;
                }
              }
            }
          // eslint-disable-next-line no-empty
          } catch (e) { }

          // A N2E user is detected
          this.showSignupForm();
        }

        return false;
      },

      /**
       * Display the signup form.
       */
      showSignupForm: function () {
        // Hide social login containers
        this.updateElementsByClassName(SOCIAL_LOGIN_WAIT_CONTAINER_CLASS, 'display', 'none');
        this.updateElementsByClassName(SOCIAL_LOGIN_ERROR_CONTAINER_CLASS, 'display', 'none');

        // Show signup form containers
        this.updateElementsByClassName(SIGNUP_ATLLOGO_CONTAINER_CLASS, 'display', 'block');
        this.updateElementsByClassName(SIGNUP_CONTENT_CONTAINER_CLASS, 'display', 'block');

        this.sendTrackingAnalytics("Viewed Signup Form", {});
      },

      /**
       * Replace checking message with preparing message
       */
      showPreparingCloudMessage: function () {
        // Hide checking... text
        this.updateElementsByClassName(SOCIAL_LOGIN_CHECKING_WAIT_TEXT_CLASS, 'display', 'none');

        // Show preparing... text
        this.updateElementsByClassName(SOCIAL_LOGIN_PREPARING_WAIT_TEXT_CLASS, 'display', 'block');
      },

      /**
       * Display the sogical login error message
       */
      showSocialLoginError: function (errorType) {
        try {
          // Update try signup again href
          const self = this;
          const linkTrySignupAgain = jQuery(`${SOCIAL_LOGIN_ERROR_TRYAGAIN_ID} a`);
          linkTrySignupAgain.prop('href', this.getTrySignupAgainUrl());
          linkTrySignupAgain.click(() => {
            self.sendTrackingAnalytics("Clicked Try Signup Button", {}, false);
            tracking.trackEvent(WAC_TRY_SIGNUP, trySignupOrigin.toAnalyticsAttributes({ hasGeneratedId: true }));
          });
        // eslint-disable-next-line no-empty
        } catch (e) { }

        // Hide social login wait container
        this.updateElementsByClassName(SOCIAL_LOGIN_WAIT_CONTAINER_CLASS, 'display', 'none');

        // Hide signup form container
        this.updateElementsByClassName(SIGNUP_CONTENT_CONTAINER_CLASS, 'display', 'none');

        // Show atlassian logo and social login error containers
        this.updateElementsByClassName(SIGNUP_ATLLOGO_CONTAINER_CLASS, 'display', 'block');
        this.updateElementsByClassName(SOCIAL_LOGIN_ERROR_CONTAINER_CLASS, 'display', 'block');

        this.sendTrackingAnalytics("Viewed Error Message", { errorType });
      },

      /**
       * Update the html elements style by class name
       */
      updateElementsByClassName: function (className, stylePropName, stylePropValue) {
        try {
          const allElems = document.getElementsByClassName(className);
          for (let i = 0; i < allElems.length; i++) {
            allElems[i].style[stylePropName] = stylePropValue;
          }
        // eslint-disable-next-line no-empty
        } catch (e) { }
      },

      /**
       * Determine the eligible sites for the user to add the new product
       */
      getEligibleSites: function (user, productKeys) {
        let eligibleSites = [];

        try {
          if (!user || !hamlet.isLoggedIn()) {
            return eligibleSites;
          }

          // sites as Free edition or regular trial should be eligible to be overlaid
          const extendedTrialOverridableSites = hamlet.getExtendedTrialAvailableSites();

          // filter users sites by products keys being signed up for
          eligibleSites = hamlet.getSites().filter((site) => {
            return !_.some(site.products, (product) => productKeys.indexOf(product) > -1) || extendedTrialOverridableSites.includes(site.cloudId);
          });
        // eslint-disable-next-line no-empty
        } catch (e) { }

        return eligibleSites;
      },

      getCurrentSearchParam: function () {
        const location = Environment.getWindowLocation();
        const internationalSubdomain = Environment.getInternationalSubdomain();

        let search = location.search;
        if (internationalSubdomain && !localeParam) {
          search = search.length ? `${search}&lang=${internationalSubdomain}` : `?lang=${internationalSubdomain}`;
        }

        return search;
      },

      /**
       * Compute the Identity login with Google Url.
       */
      getContinueWithGoogleUrl: function (searchParams) {
        // Get Identity initiate Google url
        const loginGoogleUrl = `${baseIdDomain}${URL_LOGIN_GOOGLE_PATH}?`;

        // Get WAC signup social login url
        const signupSocialUrl = `${baseDomain}${URL_SIGNUP_SOCIAL_LOGIN_PATH}?${searchParams}`;

        const cobranding = `application=wac`;
        const atlOrigin = `&atlOrigin=${loginGoogleOrigin.encode()}`;
        const continueUrl = `&continue=${encodeURIComponent(signupSocialUrl)}`;
        return `${loginGoogleUrl}${cobranding}${atlOrigin}${continueUrl}`;
      },

      /**
       * Compute the Identity login with Microsoft Url.
       */
      getContinueWithMicrosoftUrl: function (searchParams) {
        // Get Identity initiate Microsoft url
        const loginMicrosoftUrl = `${baseIdDomain}${URL_LOGIN_MICROSOFT_PATH}?`;

        // Get WAC signup social login url
        const signupSocialUrl = `${baseDomain}${URL_SIGNUP_SOCIAL_LOGIN_PATH}?${searchParams}`;

        const cobranding = `application=wac`;
        const atlOrigin = `&atlOrigin=${loginMicrosoftOrigin.encode()}`;
        const continueUrl = `&continue=${encodeURIComponent(signupSocialUrl)}`;
        return `${loginMicrosoftUrl}${cobranding}${atlOrigin}${continueUrl}`;
      },

      /**
       * Compute the site rename page Url.
       */
      getRenameSiteUrl: function ({ cloudId, cloudName, requestId, productKeys, isPermitted }) {
        // Build redirect confirmation url (user segmentation)
        const confirmationParams = {
          "ondemandurl": cloudName,
          "products": productKeys.join(","),
          "cloudId": cloudId,
          "requestId": requestId,
        };
        const confirmationUrlParams = jQuery.param(confirmationParams);
        const confirmationUrl = baseDomain + URL_CONFIRMATION_PATH + "?" + confirmationUrlParams;

        // Build rename site url
        const renameSiteParams = {
          "cloudId": cloudId,
          "requestId": requestId,
          "redirecturl": encodeURIComponent(confirmationUrl),
          "isPermitted": isPermitted,
        };
        const renameSiteUrlParams = jQuery.param(renameSiteParams);
        return `${baseDomain}${URL_RENAME_SITE_PATH}?${renameSiteUrlParams}`;
      },

      /**
       * Computes WAC try cloud signup Url
       */
      getWacTryCloudSignupUrl: function () {
        return `${baseDomain}${URL_TRY_CLOUD_SIGNUP_PATH}${this.getCurrentSearchParam()}`;
      },

      /**
       * Compute try signup again Url.
       */
      getTrySignupAgainUrl: function () {
        // Get Identity ATL account logout url
        const logoutAtlUrl = `${baseIdDomain}${URL_IDENTITY_LOGOUT_PATH}?`;

        // Get WAC try cloud signup url
        const trySignupUrl = this.getWacTryCloudSignupUrl();

        const atlOrigin = `atlOrigin=${trySignupOrigin.encode()}`;
        const continueUrl = `&continue=${encodeURIComponent(trySignupUrl)}`;
        return `${logoutAtlUrl}${atlOrigin}${continueUrl}`;
      },

      /**
       * Send analytics data.
       */
      sendTrackingAnalytics: function (eventAction, eventProps, isNonInteraction = true) {
        const anonymous_id = imktUtils.storage.getCookie('ajs_anonymous_id') || '-';  // Anonymous user, otherwise send the userID
        const opt_id = 'unknown';
        const cross_domain_id = imktUtils.storage.getCookie('seg_xid') || '';

        const eventCategory = 'cart-cloud';
        const eventLabel = 'signup-social-login';
        try {
          Tracking.trackAll("cart-cloud", eventAction, eventLabel, { ...eventProps, anonymous_id, opt_id, cross_domain_id }, isNonInteraction);
        // eslint-disable-next-line no-empty
        } catch (e) { }
      },

    };
  }
}
